module.exports = __webpack_public_path__ + "img/emoji_40.e9d2304c.png";